import { useRef, useMemo } from 'react';
import { useFrame, useThree } from '@react-three/fiber';
import * as THREE from 'three';
import { useGameStore } from '../stores/gameStore';

export default function WhitePlane() {
    const fadePlaneRef = useRef();
    const { camera, viewport } = useThree();
    const phase = useGameStore(state => state.phase);

    const material = useMemo(() => new THREE.MeshBasicMaterial({
        color: 'white',
        transparent: true,
        opacity: 0.0,
        depthTest: false,
        depthWrite: false,
        blending: THREE.AdditiveBlending
    }), []);

    useFrame((state, delta) => {
        if (!fadePlaneRef.current) return;

        // Anclem el pla directament a les coordenades i rotació de la càmera
        fadePlaneRef.current.position.copy(camera.position);
        fadePlaneRef.current.quaternion.copy(camera.quaternion);

        // Empenyem una mica endavant (en Z local negatiu) perquè estigui davant les lents
        fadePlaneRef.current.translateZ(-0.5);

        // Augmentem l'escala garantint que ocupi tot el camp de visió (viewport * 2)
        fadePlaneRef.current.scale.set(viewport.width * 2, viewport.height * 2, 1);

        // Controlar Opacitat Basada en la Distància! (Com les Speedlines i partícules)
        if (phase === 'playing' || phase === 'launching') {
            const camX = camera.position.x;
            let targetOpacity = 0.0;

            if (camX >= 450) {
                // Matemàtica idèntica: progrés de 0.0 a 1.0 entre X:380 i X:563
                const progress = THREE.MathUtils.clamp((camX - 450) / (563 - 450), 0, 1);

                // Usem Math.pow per l'efecte de Drop final asimptòtic.
                // Multiplicarem pel topall de 0.5 d'opacitat màxima d'esbrillantor desitjada!
                const smoothExp = Math.pow(progress, 10);
                targetOpacity = smoothExp * 0.7;
            }

            // Lerp suau perquè no hi hagi talls tontos per frame
            material.opacity = THREE.MathUtils.lerp(material.opacity, targetOpacity, 0.05);
        } else {
            // Apaga si no estem jugant/llançant
            material.opacity = 0;
        }
    });

    return (
        <mesh ref={fadePlaneRef}>
            <planeGeometry args={[1, 1]} />
            <primitive object={material} attach="material" />
        </mesh>
    );
}
